import React, { type PropsWithChildren } from 'react';
import { StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';

import { Icon } from '../../../../../../../Icon';
import { BodyText } from '../../../../../../../Text';
import { NAVBAR_FLOATING_ACTION_SIZE } from '../../../../../../Navbar.constants';

// ─────────────────────────────────────────────────────────────────────────────

export const NavbarFloatingCurrentOrderContainer = (props: Props) => {
  const { children, shadow, title } = props;

  // ─── Styles ────────────────────────────────────────────────────────────────

  const containerStyles = [styles.container, shadow ? styles.containerShadow : undefined];

  // ───────────────────────────────────────────────────────────────────────────

  return (
    <View style={containerStyles}>
      <Icon color={theme.colors.WHITE} name="IconCourier" width={18} height={18} />

      <BodyText
        bold
        maxFontSizeMultiplier={1.2}
        numberOfLines={1}
        sizeMatch={['16']}
        style={styles.title}
      >
        {title}
      </BodyText>

      {children}
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    height: NAVBAR_FLOATING_ACTION_SIZE,
    flexShrink: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing['4'],
    borderRadius: 1000,
    backgroundColor: theme.colors.SPINACH,
    paddingHorizontal: theme.spacing['6'],
  },
  containerShadow: {
    boxShadow: '0px 8px 40px 4px rgba(14, 21, 14, 0.09)',
  },
  title: {
    flexShrink: 1,
    color: theme.colors.WHITE,
    marginTop: 3, // to better align with other elements
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = PropsWithChildren<{
  shadow?: boolean;
  title: string;
}>;
